import TabPage from "./../../../factories/tab-page";
import GenericListSearchTab from "./../../../factories/generic-list-search-tab";
import * as ko from "knockout";
class TaskUserTab extends GenericListSearchTab {
    constructor(tabPage: TabPage, parent) {
        super(tabPage, parent);
        this.SaveAllowed = parent.SaveAllowed;
    }
    SaveAllowed: KnockoutObservable<boolean>;
    SearchType() { return "Checkware-TaskUser"; }
    CustomFilter() {
        return null;
    }
    ItemCompleteCheck(): JQueryPromise<boolean> {
        var def = $.Deferred<boolean>();
        def.resolve(true);
        return def.promise();
    }
}
export default TaskUserTab;